import * as React from 'react';
import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Environment } from '@playq/octopus-common';

import { EnvToggleButton } from '/shared/EnvToggleButton';
import { IBeetleParams } from '/component/Support/BeetlesLookup/types';

export const EvnToggler: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const history = useHistory();
  const { env } = useParams<IBeetleParams>();

  const handleEnvChange = (_: React.MouseEvent<HTMLElement>, newEnv: Environment) => {
    if (newEnv !== null) {
      history.push(newEnv);
    }
  };

  return <EnvToggleButton env={env} handleEnvChange={handleEnvChange} disabled={disabled} />;
};
